import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import CustomNavigationButtons from 'components/CustomNavigationButtons/CustomNavigationButtons';
import Receipt from '@material-ui/icons/Receipt';
import Call from '@material-ui/icons/Call';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import BillingAccountDetails from 'views/ActiveServices/Details/BillingAccountDetails';
import Numbers from 'views/ActiveServices/Details/Numbers';

interface IProps {
	match: {
		path: string;
		params: {
			subpage: string;
			billingId: string;
			accountId: string;
		};
	};
}

const Details = (props: IProps) => {
	const { subpage = 'account-details', billingId, accountId } = props.match.params;
	const { path } = props.match;

	return (
		<GridContainer>
			<GridItem xs={12}>
				<CustomNavigationButtons
					path={`/dashboard/active-services/${billingId}/${accountId}`}
					tabs={[
						{
							value: 'account-details',
							icon: Receipt,
							id: 'services-account-details-tab',
						},
						{
							value: 'numbers',
							icon: Call,
							id: 'services-numbers-tab',
						},
					]}
					value={subpage}
				/>
			</GridItem>
			<GridItem xs={12}>
				<Switch>
					<Route
						path={`${path}/account-details`}
						render={(props: any) => <BillingAccountDetails {...props} />}
						exact
					/>
					<Route path={`${path}/numbers`} render={(props: any) => <Numbers {...props} />} exact />
					<Redirect to={`${path}/account-details`} />
				</Switch>
			</GridItem>
		</GridContainer>
	);
};

export default Details;
